import {
  ModelViewSummary,
  UnsavedLibraryPanelTemplate
} from '@mpm-druid/types';

export const COMPUTE_ENGINE_KEEP_ALIVE_INTERVAL = 30_000;
export const MODEL_DASHBOARD_AUTO_SAVE_DELAY = 3_000;
export const MODEL_DASHBOARD_COLUMNS = 6;
export const MODEL_DASHBOARD_CURRENT_VERSION = 1;
export const MODEL_DASHBOARD_DEFAULT_SECTION_ID = 'main';
export const MODEL_DASHBOARD_DEFAULT_SECTION_NAME = 'Main';
export const MODEL_DASHBOARD_DEFAULT_NEW_SECTION_NAME = 'New section';
export const MODEL_DASHBOARD_DEFAULT_VIEW_NAME = 'Main';
export const MODEL_DASHBOARD_DEFAULT_NEW_VIEW_NAME = 'New view';
export const MODEL_DASHBOARD_DEFAULT_PANEL_WIDTH = 3;
export const MODEL_DASHBOARD_DEFAULT_PANEL_HEIGHT = 1;
export const MODEL_DASHBOARD_DEFAULT_VIEW_REFRESH_INTERVAL = 15_000;
export const MODEL_DASHBOARD_MAX_ROWS_HEIGHT = 3;

export const MODEL_DASHBOARD_DEFAULT_VIEW_SUMMARY: ModelViewSummary = {
  id: null,
  name: MODEL_DASHBOARD_DEFAULT_VIEW_NAME,
  is_default: true,
  model_id: '',
  version: MODEL_DASHBOARD_CURRENT_VERSION,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  last_updated_by: 'comet'
};

export const DEFAULT_PYTHON_PANEL_CODE = `print("Hello MPM Python Panel!")`;
export const DEFAULT_PYTHON_PANEL_NAME = 'Python Panel';
export const DEFAULT_PANEL_LIBRARY_TEMPLATE: UnsavedLibraryPanelTemplate = {
  id: null,
  name: 'Default',
  created_at: new Date().toISOString(),
  created_by: 'comet',
  updated_at: new Date().toISOString()
};
